// extracted by mini-css-extract-plugin
module.exports = {"TextSection":"TextSection_TextSection__aqBkY","Tab":"TextSection_Tab__1V_NQ","TabLabel":"TextSection_TabLabel__33DeD","TabContent":"TextSection_TabContent__3ndWN"};